import { useState } from "react";

export const useSignUpStates = () => {
  // 入力情報定義 ============================================
  // 登録情報
  //const { email, password, userName, setEmail, setPassword, setUserName }
  // = useContext(SignUpContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [userName, setUserName] = useState("");
  // エラーメッセージ
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [userNameError, setUserNameError] = useState("");

  // メール送信有効フラグ
  const [isActiveSendMailButton, setIsActiveSendMailButton] = useState(false);
  // 次へボタン有効フラグ
  const [isActiveNextButton, setIsActiveNextButton] = useState(false);

  // 確認ダイアログ表示フラグ
  const [isShowConfirmDialog, setIsShowConfirmDialog] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
  });

  return {
    email,
    setEmail,
    emailError,
    setEmailError,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    passwordError,
    setPasswordError,
    userName,
    setUserName,
    userNameError,
    setUserNameError,
    isActiveSendMailButton,
    setIsActiveSendMailButton,
    isActiveNextButton,
    setIsActiveNextButton,
    isShowConfirmDialog,
    setIsShowConfirmDialog,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
